<template>
  <Container class="PageCaresNew">
    <ItemList :items="cares" v-slot="{item}">
      <CareItem :child="child" :care="item" />
    </ItemList>
  </Container>
</template>

<script>
import CareItem from '@/components/organisms/CareItem'
import Container from '@/components/atoms/Container'
import ItemList from '@/components/molecules/ItemList'

import careTypes from '../../../../../constants/careTypes'
import FirebaseCares from '@/firebase/cares.ts'
const firebaseCares = new FirebaseCares()

export default {
  name: 'PageCaresNew',
  layout: 'app',
  props: {
    child: {},
  },
  data() {
    return {
      cares: [],
      unsubscribeListenCares: null,
    }
  },
  computed: {
  },
  components: {
    CareItem,
    Container,
    ItemList,
  },
  methods: {
    listenNewCares() {
      this.unsubscribeListenCares = firebaseCares.listenNewCares((cares) => {
        this.cares = cares
      }, this.child.id)
    },
  },
  mounted() {
    this.listenNewCares()
  },
  beforeRouteLeave(_1, _2, next) {
    this.unsubscribeListenCares()
    next()
  },
}
</script>

<style scoped lang="scss">
.PageCaresNew {}
</style>
